import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "./vfs_fonts_custom";

pdfMake.vfs = vfsFonts;

pdfMake.fonts = {
  NotoSansDevanagari: {
    normal: "NotoSansDevanagari-Regular.ttf",
    bold: "NotoSansDevanagari-Regular.ttf",
    italics: "NotoSansDevanagari-Regular.ttf",
    bolditalics: "NotoSansDevanagari-Regular.ttf",
  },
};

console.log("PDFMAKE VERSION WORKING");

export default pdfMake;